import React, { useContext, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function SignInForm() {
    const { signIn } = useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();

    const handleSubmit = async event => {
        event.preventDefault();
        setSubmitting(true);
        setError('');
        const result = await signIn(username.trim(), password);
        setSubmitting(false);
        if (!result.token) return setError(result.error || 'Invalid email or password.');
        history.push(result.role === 'driver' ? '/driver-orders' : '/');
    };

    return (
        <main className="account-page"><section className="account-panel"><p className="eyebrow">Welcome back</p><h1>Sign in to your account.</h1><p>View current and previous orders from one place.</p><form onSubmit={handleSubmit}><label>Email or username<input value={username} onChange={event => setUsername(event.target.value)} autoComplete="username" required /></label><label>Password<span className="password-field"><input type={showPassword ? 'text' : 'password'} value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" required /><button type="button" onClick={() => setShowPassword(current => !current)} aria-label={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? <FaEyeSlash /> : <FaEye />}</button></span></label>{error && <p className="form-error" role="alert">{error}</p>}<button className="button button--primary button--wide" disabled={submitting}>{submitting ? 'Signing in...' : 'Sign in'}</button></form><p className="account-switch">New to Divine Veg? <Link to="/register">Create an account</Link></p></section></main>
    );
}

export default SignInForm;
